import React from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function PreviewDialogBox({ open, onClose, familyId, previewUrl }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle sx={{ position: 'relative' }}>
        Preview Pedigree {familyId ? `— ${familyId}` : ''}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 12, top: 15, color: 'inherit' }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {previewUrl ? (
          <iframe
            title={`pedigree-preview-${familyId}`}
            src={previewUrl}
            style={{ width: '100%', height: '80vh', border: 0 }}
          />
        ) : (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <CircularProgress />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default PreviewDialogBox;
